import { ReactComponent as NewStatusIcon } from '../../../../assets/icons/status/new.svg';
import { ReactComponent as PassedStatusIcon } from '../../../../assets/icons/status/passed.svg';
import { ReactComponent as InReviewStatusIcon } from '../../../../assets/icons/status/in-review.svg';
import { ReactComponent as RejectedStatusIcon } from '../../../../assets/icons/status/rejected.svg';
import { ReactComponent as DraftStatusIcon } from '../../../../assets/icons/status/draft.svg';
import { ReactComponent as NeedCheckingIcon } from '../../../../assets/icons/status/need_checking.svg';
import { STATUS } from '@/utils/static/kyc';

export const STATUS_ICON = {
  [STATUS.NEW]: <NewStatusIcon width={16} height={16} />,
  [STATUS.DRAFT]: <DraftStatusIcon width={16} height={16} />,
  [STATUS.PROCESSING]: <InReviewStatusIcon width={16} height={16} />,
  [STATUS.QUESTION_UNACCEPTED]: <RejectedStatusIcon width={16} height={16} />,
  [STATUS.REJECTED]: <RejectedStatusIcon width={16} height={16} />,
  [STATUS.NEED_CHECKING]: <NeedCheckingIcon width={16} height={16} />,
  New: <NewStatusIcon width={16} height={16} />,
  'In process': <InReviewStatusIcon width={16} height={16} />,
  Rejected: <RejectedStatusIcon width={16} height={16} />,
  ACCEPTED: <PassedStatusIcon width={16} height={16} />
};

